import React, { useState } from "react";
import ReactToPdf from "react-to-pdf";

function DownloadPdf(props) {
  const ref = React.createRef();

  //   const [show, setShow] = useState(false);
  const downloadFun = (e, toPdf) => {
    // setShow(true);
    setTimeout(() => {
      toPdf(e);
    }, 1000);
  };
  const onCompleteDownload = (e) => {
    // setShow(false);
    props.onComplete();
  };

  return (
    <div>
      <div ref={ref}>{props?.image}</div>
      <div>
        <ReactToPdf
          targetRef={ref}
          filename={props?.title || "div-blue.pdf"}
          onComplete={onCompleteDownload}
        >
          {({ toPdf }) => (
            <div className="d-flex align-items-center py-3 mt-4">
              {props?.cancel}
              <button
                className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                type="button"
                id="print-to-pdf-button"
                onClick={toPdf}
              >
                Export
              </button>
            </div>
          )}
        </ReactToPdf>
      </div>
    </div>
  );
}

export default DownloadPdf;
